import React from 'react'
import {
   DataGrid,
   DataGridHeader,
   DataGridRow,
   DataGridHeaderCell,
   DataGridBody,
   DataGridCell,
   shorthands,
   tokens,
   makeStyles,
   TableColumnDefinition,
   mergeClasses,
   TableColumnSizingOptions,
} from '@fluentui/react-components'
import { PhoneList } from './PhoneList'

const useStyles = makeStyles({
   content: {
      overflow: 'hidden',
      ...shorthands.padding(tokens.spacingVerticalL, 0, tokens.spacingHorizontalXXL, 0),
   },
   pointer: {
      cursor: 'pointer',
      boxSizing: 'border-box',
   },
   bold: { '& > *': { fontWeight: tokens.fontWeightBold } },
   hideInPhone: {
      '@media screen and (max-width: 1007px)': {
         display: 'none',
      },
   },
   stickyHeader: {
      position: 'sticky',
      top: 0,
      zIndex: 2,
   },

   dataGrid: {
      height: '100%',
      overflowY: 'auto',
      minWidth: 'auto !important',
      boxSizing: 'border-box',
      overflowX: 'hidden',
   },
})

type ListProps<T extends {}> = {
   columns: TableColumnDefinition<T>[]
   items: T[]
   renderPhoneBodyItem: (item: T, index: number) => JSX.Element
   onRowClick?: (item: T) => void
   onCellClick?: (item: T, columnKey: keyof T) => void
   className?: string
   resizableColumns?: boolean
   columnSizingOptions?: TableColumnSizingOptions
   sortable?: boolean
   beigeHeaderBackground?: boolean
}
export const List = <T extends {}>({
   columns,
   items,
   renderPhoneBodyItem,
   onRowClick,
   onCellClick,
   className,
   resizableColumns,
   columnSizingOptions,
   sortable,
   beigeHeaderBackground,
}: ListProps<T>) => {
   const classes = useStyles()
   return (
      <>
         <section className={mergeClasses(classes.content, classes.hideInPhone, className ?? '')}>
            <DataGrid
               sortable={sortable ?? false}
               items={items}
               columns={columns}
               resizableColumns={resizableColumns ?? false}
               columnSizingOptions={columnSizingOptions}
               className={classes.dataGrid}
            >
               <DataGridHeader
                  style={{ backgroundColor: beigeHeaderBackground ? tokens.colorPaletteMarigoldBackground1 : tokens.colorNeutralBackground4 }}
                  className={classes.stickyHeader}
               >
                  <DataGridRow className={classes.bold}>{({ renderHeaderCell }) => <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>}</DataGridRow>
               </DataGridHeader>
               <DataGridBody<T>>
                  {({ item, rowId }) => (
                     <DataGridRow<T>
                        key={rowId}
                        className={onRowClick ? classes.pointer : ''}
                        onClick={() => (onCellClick ? undefined : onRowClick && onRowClick(item))}
                     >
                        {({ renderCell, columnId }) => (
                           <DataGridCell onClick={onCellClick ? () => onCellClick(item, columnId as keyof T) : undefined}>{renderCell(item)}</DataGridCell>
                        )}
                     </DataGridRow>
                  )}
               </DataGridBody>
            </DataGrid>
         </section>
         <PhoneList items={items} onRowClick={onRowClick} renderBodyItem={renderPhoneBodyItem} />
      </>
   )
}
